/// <amd-module name="Comments/Thread/Components/AddComment" />
import { IComment } from "Comments/Common/Contracts";
import { CommentEditor } from "Comments/Editor/CommentEditor";
import { IAddCommentProps } from "Comments/Thread/Components/AddComment.Props";
import * as Resources from "Comments/Thread/Resources";
import * as React from "react";
import { PersonaDetailsProvider } from "VSS/Features/Identities/PersonaDetailsProvider";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { css, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IPageData, IVssPageService } from "VSS/Platform/Page";
import { Button } from "VSSUI/Button";
import { IPersonaProvider, Persona, PersonaSize } from "VSSUI/Persona";
import { getSafeId } from "VSSUI/Util";

export class AddComment extends VssComponent<IAddCommentProps, {}> {
    private _currentUser: IdentityRef | undefined;
    private _personaProvider: IPersonaProvider;

    constructor(props: IAddCommentProps, context: IVssComponentContext) {
        super(props, context);

        const pageService: IVssPageService = context.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData: IPageData | undefined = pageService.getData();
        this._currentUser = pageData && pageData.user;

        this._personaProvider = new PersonaDetailsProvider(context.pageContext);
    }

    public render(): JSX.Element {
        const { onRenderEditor, onEditorMounted, className, disabled, isEditing, onRenderPreview, text, uploadImageHandler } = this.props;
        const addACommentEditorId = getSafeId("add-a-comment-editor");

        let comment: IComment = {
            id: -1,
            createdDate: new Date(),
            createdOnBehalfDate: new Date(),
            createdBy: this._currentUser!,
            createdOnBehalfOf: this._currentUser!,
            modifiedDate: new Date(),
            text: text,
            renderedText: "",
            version: 0,
            isDeleted: false,
            reactions: []
        };

        return (
            <div className={css("flex-row flex-grow add-comment", className)}>
                {this._currentUser && (
                    <Persona
                        className="comment-avatar"
                        identity={this._currentUser}
                        size={PersonaSize.size32}
                        personaProvider={this._personaProvider}
                    />
                )}
                {!isEditing && (
                    <Button className="add-button flex-grow" onClick={this._addCommentClicked} disabled={disabled} ariaLabel={Resources.AddAComment}>
                        <span className="flex-row justify-start flex-grow">{Resources.AddAComment}</span>
                    </Button>
                )}
                {isEditing && (
                    <CommentEditor
                        className="flex-grow add-comment-editor"
                        comment={comment}
                        originalText=""
                        onUpdate={this._onAddComment}
                        onDirtyChange={this._onDirtyChange}
                        onCancelEdit={this._onCancelEdit}
                        onRenderPreview={onRenderPreview}
                        onRenderEditor={onRenderEditor}
                        onEditorMounted={onEditorMounted}
                        updateButtonText={Resources.Add}
                        uploadImageHandler={uploadImageHandler}
                        ariaLabel={Resources.AddAComment}
                        ariaLabelledBy={addACommentEditorId}
                        placeholder={Resources.AddAComment}
                    >
                    </CommentEditor>
                )}
            </div>
        );
    }

    private _addCommentClicked = (): void => {
        const { onStartEditing } = this.props;

        onStartEditing();
    };

    private _onAddComment = (commentId: number, newValue: string, oldValue: string): void => {
        const { onAdd } = this.props;

        onAdd(newValue);
    };

    private _onCancelEdit = (commentId: number, isDirty: boolean): void => {
        const { onCancelEditing } = this.props;

        if (onCancelEditing) {
            onCancelEditing();
        }
    };

    private _onDirtyChange = (commentId: number, isDirty: boolean): void => {
        const { onDirtyChange } = this.props;

        if (onDirtyChange) {
            onDirtyChange(isDirty);
        }
    };
}
